<template>
    <div class="w-100 pa-0 pt-1">
        <div class="v-flex">
            <div class="lm-border mr-2 pa-2 pb-1" style="width: 150px">
                <c-inspection-scope-compact
                    :inspection = "inspection"
                    @menu       = "onMenu"
                />
            </div>
            <div class="lm-border disposition-header" style="width: calc(100% - 150px)">
                <v-row dense>
                    <v-col dense class="col-6 pr-1">
                        <f-read-only-field
                            label  = "Gutachter"
                            :value = "inspection.technicianName ? inspection.technicianName : '---'"
                            filled
                            dense
                        />
                    </v-col>

                    <v-col class="col-3 pl-1 pr-1">
                        <f-read-only-field
                            label  = "Status"
                            :value = "inspection.done ? $t('disposition.status.done') : $t('disposition.status.inProcess')"
                            filled
                            dense
                        />
                    </v-col>

                    <v-col class="col-3 pl-1">
                        <f-read-only-field
                            :label = "$t('disposition.inspection.created')"
                            :value = "formatDateTime(inspection.createdDate)"
                            filled
                            dense
                        />
                    </v-col>
                </v-row>

                <v-row dense class="mt-2">
                    <v-col class="col-3 pr-1">
                        <f-read-only-field
                            :label = "$t('disposition.inspection.id')"
                            :value = "elevatorId"
                            filled
                            dense
                        />
                    </v-col>
                    <v-col class="col-3 pl-1 pr-1">
                        <f-date-picker
                            v-if    = "!inspection.download"
                            label   = "disposition.inspection.date"
                            :time   = "false"
                            v-model = "inspection.inspectionDate"
                            @input  = "onInspectionDate"
                        />
                        <f-read-only-field
                            v-if="inspection.download"
                            :label = "$t('disposition.inspection.date')"
                            :value = "formatDate(inspection['inspectionDate'])"
                            filled
                            dense
                        />
                    </v-col>

                    <v-col class="col-3 pl-1 pr-1">
                        <f-read-only-field
                            :label = "$t('disposition.inspection.download')"
                            :value = "formatDateTime(inspection.download)"
                            filled
                            dense
                        />
                    </v-col>
                    <v-col class="col-3 pl-1">
                        <f-read-only-field
                            :label = "$t('disposition.inspection.lastUpload')"
                            :value = "formatDateTime(inspection.upload)"
                            filled
                            dense
                        />
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="w-100 mt-2">

            <div class="mt-2 w-100">
                <div
                    v-if        = "page === 'CONTACTS'"
                >
                    <div class="v-flex">
                        <div class=" w-50 mb-4 pr-2">
                            <c-column-header
                                label = "Bemerkungen"
                                class="primary white--text"
                                :title-border = "true"
                            >
                                <template v-slot:toolbar>
                                    <c-toolbar-button
                                        icon="mdi-content-save"
                                        color="white"
                                        size="20"
                                        style="margin-top: -1px; padding-right: 4px;"
                                        @click = "onStore"
                                        tooltip="Bemerkung speichern"
                                    />
                                </template>
                            </c-column-header>
                            <div class="lm-border bottom-border-radius pa-2" style="border-top-style: none; height: 150px">
                                <v-textarea
                                    v-model        = "inspection.comment"
                                    rows           = "5"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    class          = "pt-0"
                                    no-resize
                                    hide-details
                                />
                            </div>

                        </div>
                        <div class=" w-50 mb-2 pl-2">
                            <c-column-header
                                label = "Verwender"
                                class="primary white--text"
                                :title-border = "true"
                            >
                            </c-column-header>

                            <div class="lm-border bottom-border-radius pa-2" style="border-top-style: none; height: 150px">
                            </div>

                        </div>
                    </div>

                    <c-inspection-contacts
                        :inspection = "inspection"
                        :height     = "height"
                    />

                </div>

                <p-disposition-elevator-data
                    v-if        = "page === areas.UNIT"
                    :inspection = "inspection"
                    :height     = "height"
                    @refresh    = "onRefresh"
                />

                <p-disposition-sticker
                    v-if        = "page === areas.STICKER"
                    :inspection = "inspection"
                    :height     = "height"
                />

                <p-disposition-lift-guardian
                    v-if        = "page === areas.LGS"
                    :inspection = "inspection"
                    :height     = "height"
                />

                <p-disposition-condition
                    v-if        = "page === areas.CONDITIONS"
                    :inspection = "inspection"
                    :height     = "height"
                />

                <c-disposition-audit
                    v-if        = "page === areas.GBU"
                    :type       = "areas.GBU"
                    :inspection = "inspection"
                    :height     = "height"
                />

                <c-disposition-audit
                    v-if        = "page === areas.ESG"
                    :type       = "areas.ESG"
                    :inspection = "inspection"
                    :height     = "height"
                />

                <c-inspection-images
                    v-if        = "page === areas.BOOK"
                    type        = "BOOK"
                    :title      = "$t('disposition.book.menu')"
                    :key        = "page"
                    :inspection = "inspection"
                    :height     = "height"
                />

                <c-inspection-images
                    v-if        = "page === areas.IMAGES"
                    type        = "IMAGE"
                    :title      = "$t('disposition.images.menu')"
                    :key        = "page"
                    :inspection = "inspection"
                    :height     = "height"
                />
            </div>
        </div>
    </div>
</template>

<script>

import Core                     from "@/modules/core/service/Core";
import Disposition              from "@/modules/dis/service/Disposition";
import FReadOnlyField           from "@/modules/core/components/utils/FReadOnlyField.vue";
import PDispositionElevatorData from "@/modules/dis/components/inspection/elevator/components/PDispositionElevatorData.vue";
import PDispositionSticker      from "@/modules/dis/components/inspection/stickers/components/PDispositionSticker.vue";
import PDispositionLiftGuardian from "@/modules/dis/components/inspection/lgsmart/components/PDispositionLiftguardian.vue";
import PDispositionCondition    from "@/modules/dis/components/inspection/condition/components/PDispositionCondition.vue";
import CDispositionAudit        from "@/modules/dis/components/inspection/audit/components/CDispositionAudit.vue";
import CInspectionImages        from "@/modules/dis/components/inspection/images/components/CInspectionImages.vue";
import FDatePicker              from "@/modules/core/components/utils/FDatePicker.vue";
import CInspectionContacts from "@/modules/dis/components/inspection/contacts/components/CInspectionContacts.vue";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import CInspectionScopeCompact from "@/modules/dis/components/inspection/common/components/CInspectionScopeCompact.vue";

export default {
    name: "CDispositionUnit",

    components: {
        CInspectionScopeCompact,
        CToolbarButton,
        CColumnHeader,
        CInspectionContacts,
        FDatePicker,
        CInspectionImages,
        CDispositionAudit,
        PDispositionCondition,
        PDispositionLiftGuardian,
        PDispositionSticker,
        PDispositionElevatorData,
        FReadOnlyField,
    },

    props: {
        inspection: {

        },

        height: {

        },

        area: {

        }
    },

    data: () => ({
        page      : "CONTACTS",
        technician: null
    }),

    computed: {
        areas () {
            return Disposition.inspection.areas
        },

        elevatorId () {
            let id = this.inspection.unitId ? this.inspection.unitId : "NEU";

            if (this.inspection.elevatorNo) {
                if (id) {
                    id += " - "
                }

                id += this.inspection.elevatorNo;
            }

            return id;
        },
    },

    watch: {
        inspection () {
            this.initialize();
        },

        area () {
            this.page = this.area;
        }
    },

    created() {
        this.$bus.$on(this.$events.dis.inspection, this.onInspection);
    },

    mounted () {
        this.initialize();
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.dis.inspection, this.onInspection);
    },

    methods: {
        initialize () {
            if (!this.inspection) {
                this.page = null;
                return;
            }

            this.technician = {
                id: this.inspection.technicianId
            }

    //        this.page = "CONTACTS";
//                this.page = Disposition.inspection.firstPage(this.inspection);
        },

        onRefresh (inspection) {
            this.$emit("refresh", inspection)
        },

        onInspectionDate () {
            Disposition.inspection.store(this.inspection).then(() => {
                Core.message.alert.save(this);
                this.$emit("technician")
            });
        },

        onStore () {
            Disposition.inspection.store(this.inspection).then(() => {
                Core.message.alert.save(this);
                this.$emit("saved", this.inspection)
            });
        },

        onInspection () {

        },

        onMenu (entry) {
            this.$emit("menu", entry);
        },

        formatDateTime (value) {
            return Core.format.datetime.display(value);
        },

        formatDate (value) {
            return Core.format.date.display(value);
        },

        setTechnician () {
            if (!this.technician) {
                this.inspection.technicianId = null;
                this.inspection.technicianName = null;
                this.inspection.technicianIdent = null;
            } else {
                this.inspection.technicianId = this.technician.id;
                this.inspection.technicianName = this.technician.name;
                this.inspection.technicianIdent = this.technician.ident;
            }


            Disposition.inspection.store(this.inspection).then(() => {
                Core.message.alert.save(this);
                this.$emit("technician")
            });
        }
    }
}
</script>

<style scoped>

.disposition-header {
    padding: 15px 12px 12px;
    height: 150px;
}
:deep(.v-input__control textarea) {
    border: none!important;
}

</style>